import { render, staticRenderFns } from "./ResellerPaymentListTable.vue?vue&type=template&id=2338dc4c&"
import script from "./ResellerPaymentListTable.vue?vue&type=script&lang=js&"
export * from "./ResellerPaymentListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports